module.exports = __webpack_public_path__ + "static/media/night.10b51945.png";